import React from 'react';
import { connect } from 'react-redux';

import * as Types from 'types';
import { ErrorModal } from 'components/modal';
import { hideErrorModal } from 'features/modals/actions';

type Props = {
  errorModalActive: boolean;
  hideErrorModal: () => void;
  errorModalMessage?: string;
};

const AppErrorModal = (props: Props) => (
  <ErrorModal
    isOpen={props.errorModalActive}
    portalClassName='error-modal-portal'
    onRequestClose={() => props.hideErrorModal()}
  >
    {props.errorModalMessage || 'Error has occurred during your request. Please try again.'}
  </ErrorModal>
);

const mapStateToProps = ({ modals }: Types.RootState) => ({
  errorModalActive: modals.errorModalActive,
  errorModalMessage: modals.errorModalMessage,
});

const mapDispatchToProps = {
  hideErrorModal,
};

export const ErrorModalContainer = connect(mapStateToProps, mapDispatchToProps)(AppErrorModal);
